
const digest = '4e1b18af64a3919a78c3a436400067f5b766ca9b8db2df0159c54d6a8166fa06';
const classes = {"signatureWrapper":"_signatureWrapper_1tumf_1","signature":"_signature_1tumf_1","title":"_title_1tumf_23","buttonWrapper":"_buttonWrapper_1tumf_28"};
const css = `._signatureWrapper_1tumf_1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}
._signatureWrapper_1tumf_1 ._signature_1tumf_1 {
  font-family: Rubik, "sans-serif";
  border: 3px solid #eaedf3;
  aspect-ratio: 2.3/1;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-direction: column;
  gap: 20px;
}
._signatureWrapper_1tumf_1 ._signature_1tumf_1 img {
  max-width: 100%;
  max-height: 100%;
}
._signatureWrapper_1tumf_1 ._signature_1tumf_1 ._title_1tumf_23 {
  font-size: 16px;
  font-weight: 600;
}

._buttonWrapper_1tumf_28 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  